<template>
    <table-page
        @update:topBut="topBut"
        @update:nodeBut="nodeBut"
        @update:handleSelectionChange="handleSelectionChange"
        :but-no-manage="noManage"
        ref="tablePageRef">

        <menus ref="menusRef" :params="{'m': 'store'}" :data-url="menusUrl" @update:onUrlChange="onUrlChange"></menus>
        <add ref="addFormRef" :title="formTitle" :urls="urls" @update:getDataList="getDataList">
            <template #form_top>
                <el-button type="warning" @click="menusToForm">系统连接</el-button>
            </template>
        </add>
        <form-page
            v-if="isload"
            :page-type="pageInfo.page_type"
            :title="pageTitle"
            :pageInfo="pageInfo"
            :forms="formobj"
            @update:onSubmit="onSubmit"
        />

    </table-page>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, provide, reactive } from 'vue'
    import TablePage from '../../common/table'
    import Add from '../../common/form'
    import Menus from '../../common/menus'
    import FormPage from '@/components/ui-form-page'
    import { Host } from '@/config/index'

    export default defineComponent({
        components: {
            TablePage,
            FormPage,
            Add,
            Menus
        },
        setup() {
            const { proxy } = getCurrentInstance()
            const selectIds = ref()
            const urls = proxy.$router.currentRoute.value.meta.urls
            const noManage = ['topAdd', 'nodeEdit']

            const tablePageRef = ref()
            const formTitle = ref()
            const addFormRef = ref()

            const isload = ref(false)
            const pageTitle = ref()
            const formobj = ref({})
            const pageInfo = ref()
            const dialogFormVisible = ref(false)
            const dialogMenusVisible = ref(false)
            const menusRef = ref()
            const appType = ref()
            const menusUrl = `${Host}store/shared/menu/menus`
            const onUrlChange = (e) => {
                addFormRef.value.formobj.map((item) => {
                    if (item.name === 'name') {
                        item.value = e.name
                    }
                    if (item.name === 'url') {
                        item.value = e.url
                    }
                })
                dialogMenusVisible.value = false
            }

            const topBut = (e) => {
                if (e === 'Add') {
                    getInfo()
                }
            }

            const getInfo = (map = {}, url = urls.add) => {
                isload.value = false
                proxy.jiu.request(url, map).then((res, rej) => {
                    formobj.value = res.data.form_items
                    pageInfo.value = res.data
                    isload.value = true
                    pageTitle.value = res.data.page_title
                    dialogFormVisible.value = true
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }

            const onSubmit = (obj) => {
                proxy.jiu.request(urls.add, obj, 'POST').then((res, rej) => {
                    dialogFormVisible.value = false
                    addFormRef.value.add({ ad_position_id: res.data.id }).then(() => {
                        addFormRef.value.formobj.map((item) => {
                            if (item.name === 'navtype') {
                                appType.value = item.value
                            }
                        })
                    })
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }

            const getDataList = (e) => {
                tablePageRef.value.getDataList()
            }
            const nodeBut = (e, data, index) => {
                if (e === 'Edit') {
                    addFormRef.value.edit({ id: data.id }).then(() => {
                        addFormRef.value.formobj.map((item) => {
                            if (item.name === 'navtype') {
                                appType.value = item.value
                            }
                        })
                    })
                }
            }

            const handleSelectionChange = (e) => {
                selectIds.value = e
            }

            const menusToForm = () => {
                menusRef.value.setAppType(appType.value)
                dialogMenusVisible.value = true
            }
            provide('dialogFormVisible', dialogFormVisible)
            provide('dialogMenusVisible', dialogMenusVisible)
            return {
                getDataList,
                topBut,
                nodeBut,
                handleSelectionChange,

                tablePageRef,
                urls,
                addFormRef,
                formTitle,
                noManage,

                isload,
                pageInfo,
                pageTitle,
                formobj,
                onSubmit,

                menusRef,
                onUrlChange,
                menusToForm,

                menusUrl
            }
        }
    })
</script>
<style>
    .database-page .data-table .el-table__body-wrapper {
        height: calc(100vh - 325px);
    }
</style>
